import { Button, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';
import Axios from '../utils/axios';
import Pagination from '../../globalComponents/Pagination';
import Search from '../../globalComponents/Search';



const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Internal Reference',
    dataIndex: 'internal_reference',
    key: 'internal_reference',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Sales Price',
    dataIndex: 'sales_price',
    key: 'sales_price',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Cost Price',
    dataIndex: 'cost_price',
    key: 'cost_price',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    
  }
]



const Products = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const { CustomBreadcrumb } = useOutletContext();
  const [search, setSearch] = useState('');
  const [searchProduct, setSearchProducts]= useState({products: loader.products ? loader.products : [], totalRows: loader.totalRows});
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  const onRow = (record, rowIndex) => {
    if (window.location.pathname.startsWith('/sales')) {
      return {
        onClick: () => navigate('/sales/products/'+record.seo)
      };
    }
  }
 
  const handleChange = (e, option) => {
    let value_ = e.map(item => item.toLowerCase());
    setSearch(value_)
  }

  async function fetchUserList(search, pagination_) {

    return Axios(`products/query?seo=${search}&&pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setSearchProducts(res);      
      });
  }

  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {by: searchBy, values: search, filters: selectedFilters}};
    fetchUserList(search, pagination_);
  },[search, paginations])

  useEffect(() => {
    if (window.location.pathname.startsWith('/sales')) {
      columns[columns.length - 1].render = (_, record) => (
        <Link className='h-full w-full' to={'/sales/products/'+record.seo}>
          EDIT
        </Link>
      )
    }else {
      columns[columns.length - 1].render = (_, record) => (
        <span>EDIT</span>
      )
    }
  },[])

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><CustomBreadcrumb/></h3>
        <div className='w-1/2 bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Search search={search.length > 0 ? search : null} handleChange={handleChange}/>
        </div>
      </div>
      <div className={`columns-2 mx-4 my-2 flex justify-${window.location.pathname.startsWith('/sales') ? 'between' : 'end'}`}>
        {window.location.pathname.startsWith('/sales') && <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/sales/products/new'} className='w-full'>New</Link>
          </Button>
        </div>}
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
          <Pagination paginations={paginations} total={searchProduct.totalRows} setPaginations={setPaginations}/>
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={searchProduct.products.length > 0 ? searchProduct.products : loader.products}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'name'}
      />
    
    </div>
  )
}

export default Products;